import { gql } from '@polleverywhere/graphql-client'

export const activePresenter = gql`
  query activePresenter ($username: String!) {
    activityPresenter(username: $username) {
      id
      login
      name
      webBranded
      pinnedParticipantKey
      customStyle {
        placeholderLogo
        placeholderTitle
        placeholderContent
        mobileTheme
        javascriptUrl
        stylesheetUrl
      }
    }

    participantRegistrationInfo(username: $username) {
      existingParticipant
      organization
      participationCost
      participantSelfRegistration
      preregistrationMessage
      firehoseToken
      samlLogins {
        loginLabel
        loginUrl
      }
      registrationSuggested
      requiresPaidParticipation
      screenNamesEnabled
      competitionScreenNamesEnabled
    }

    participantPresenterRelationship(username: $username) {
      id
      screenName
    }
  }
`

export const refreshRegistrationInfo = gql`
  query refreshRegistrationInfo ($username: String!) {
    participantRegistrationInfo(username: $username) {
      existingParticipant
      organization
      participationCost
      participantSelfRegistration
      preregistrationMessage
      firehoseToken
      samlLogins {
        loginLabel
        loginUrl
      }
      registrationSuggested
      requiresPaidParticipation
      screenNamesEnabled
      competitionScreenNamesEnabled
    }

    participantPresenterRelationship(username: $username) {
      id
      screenName
    }
  }
`

export const updateScreenName = gql`
  mutation updateScreenName ($input: ScreenNameInput!) {
    updateScreenName(input: $input) {
      id
      screenName
    }
  }
`
